/* eslint-disable complexity */
import React, { DragEvent } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import Icon from 'carbon-react/lib/components/icon';

import { ReportTemplate } from '../../types';
import { ThumbnailsSlider } from './thumbnails-slider/thumbnails-slider';
import { useI18nConstants } from '../../use-i18n-constants';

import * as styles from './report-card.scss';

interface Props {
  orientation: 'portrait' | 'landscape' | 'dashboard';
  hasAddIcon?: boolean;
  isTemplate?: boolean;
  report?: ReportTemplate;
  title?: string;
  onClick?: () => void;
  onDragStart?: (e: DragEvent<HTMLDivElement>) => void;
  isDraggable?: boolean;
  isDisabled?: boolean;
  large?: boolean;
}
export const ReportCard = ({
  isTemplate,
  orientation,
  report,
  hasAddIcon,
  title,
  onClick,
  isDraggable,
  isDisabled,
  onDragStart,
  large
}: Props) => {
  const intl = useIntl();
  const { orientations } = useI18nConstants();
  const thumbnails = report?.thumbnail_urls;

  const handleOnClick = () => {
    onClick && onClick();
  };

  const textToShow =
    report?.name ||
    title ||
    (isTemplate
      ? intl.formatMessage(
          { id: 'reporting.orientation_template', defaultMessage: '{orientationName} template' },
          { orientationName: orientations[orientation] }
        )
      : intl.formatMessage(
          { id: 'reporting.orientation_report', defaultMessage: '{orientationName} report' },
          { orientationName: orientations[orientation] }
        ));

  return (
    <div
      className={classNames(
        styles.card,
        styles[orientation],
        isDisabled && styles.disabled,
        { [styles.large]: large },
        { [styles.clickable]: !!onClick }
      )}
      onClick={handleOnClick}
      draggable={isDraggable}
      onDragStart={onDragStart}
      data-testid="ReportCard"
    >
      {large ? textToShow : null}
      {hasAddIcon && <Icon type="add" fontSize="medium" bgShape="rounded-rect" color="#00A159" mb={1} />}
      {!large ? textToShow : null}
      {!!thumbnails?.length && <ThumbnailsSlider slides={thumbnails} />}
      {!thumbnails?.length && report && (
        <div className={styles.pagesNumber}>
          {intl.formatMessage(
            {
              id: 'reporting.number_pages',
              defaultMessage: '{count, plural, one {# page} other {# pages}}'
            },
            { count: report.page_count }
          )}
        </div>
      )}
    </div>
  );
};
